import API_ENDPOINTS from "../config/apiEndpoints";
import { requestWithAuth } from "./apiClient";

export const apiDepartamentosService = {
  getById: async (idDepartamento) => {
    const response = await requestWithAuth(
      API_ENDPOINTS.DEPARTAMENTO.ONE(idDepartamento)
    );

    return response.json();
  },
  putById: async (idDepartamento, json) => {
    const response = await requestWithAuth(
      API_ENDPOINTS.DEPARTAMENTO.ONE(idDepartamento),
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(json),
      }
    );

    return response.json();
  },
  deleteById: async (idDepartamento) => {
    const response = await requestWithAuth(
      API_ENDPOINTS.DEPARTAMENTO.ONE(idDepartamento),
      { method: "DELETE" }
    );

    return response.json();
  },
  getAllPageable: (idEmpresa, page, size) => {
    return API_ENDPOINTS.DEPARTAMENTO.ALL(idEmpresa, page, size); // Devuelve directamente la URL
  },
  getAll: async (idEmpresa, page, size) => {
    const response = await requestWithAuth(
      API_ENDPOINTS.DEPARTAMENTO.ALL(idEmpresa, page, size),
      { method: "GET" }
    );
    return response.json();
  },
  create: async (json) => {
    const response = await requestWithAuth(API_ENDPOINTS.DEPARTAMENTO.CREATE, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(json),
    });

    return response.json();
  },
};
